module.exports = __webpack_public_path__ + "img/borderMiddleBracketsWhite.459fd89f.svg";